module.exports = __webpack_public_path__ + "media/application/images/svgs/logo-a08126433191914e150b275b6732bbb9.svg";